import React from 'react';
import {Tag} from "antd";

function TagInfo({label,children, color='#f5f5f5', style, labelStyle={}, valueStyle={}}) {
	const childrenToUse =  (children instanceof Number || typeof children === 'number')  ? children.toString() : children
	return (
		<div>
		<Tag
		size="small"
		color={color}
		style={{
			display: "flex",
			padding: 0,
			...style
		}}
		>
			{/* Label Section */}
			<div
			style={{
				background: "rgba(100,100,100,0.06)", // Light grey background
				padding: "1px 6px",
				textAlign: "center",
				borderRight: "1px solid rgba(125,125,125,0.2)", // Subtle divider
				...labelStyle
			}}
			>
				{label}
			</div>

			{/* Value Section */}
			<div style={{ padding: "1px 6px", flex: 1, textAlign:'right',...valueStyle }}>
				{childrenToUse}
			</div>
		</Tag>
		</div>
		);
}

export default TagInfo;